<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="searchForm" class="demo-form-inline" ref="searchform">
						<el-form-item :label="$t('protocol.name')">
							<el-input v-model="searchForm.name" :placeholder="$t('protocol.name')"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="search">{{ $t('device.inquire') }}</el-button>
							<el-button @click="reset">{{ $t('device.reset') }}</el-button>
						</el-form-item>
					</el-form>
					<el-button type="primary" @click="handleEdit">{{ $t('goods.add') }}</el-button>
				</div>
			</template>

			<el-table :data="tableData" border stripe>
				<el-table-column prop="id" :label="$t('protocol.id')" width="180"></el-table-column>
				<el-table-column prop="name" :label="$t('protocol.name')" width="280"></el-table-column>
				<el-table-column prop="type" :label="$t('protocol.type')" width="150">
					<template #default="{row}">
						{{ protocolTypeOptions.find(i => i.value === row.type)?.label || '-' }}
					</template>
				</el-table-column>
				<el-table-column prop="description" :label="$t('protocol.description')"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="200">
					<template #default="{row}">
						<el-button size="small" @click="handleEdit(row)">{{ $t('device.edit') }}</el-button>
						<el-button size="small" type="danger" @click="handleDelete(row)">{{ $t('goods.delete') }}</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-dialog :title="editTitle" v-model="dialogVisible" width="40%">
				<el-form :model="editForm" label-width="120px">
					<el-form-item :label="$t('protocol.name')">
						<el-input v-model="editForm.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('protocol.type')">
						<el-select v-model="editForm.type" :placeholder="$t('protocol.select_type')">
							<el-option v-for="item in protocolTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('protocol.description')">
						<el-input v-model="editForm.description" type="textarea"></el-input>
					</el-form-item>
						<el-form-item :label="$t('protocol.config')">
							<div class="config-actions">
								<el-button size="small" type="primary" @click="applyDefaultMenu">{{ $t('protocol.apply_default_menu') }}</el-button>
								<el-button size="small" @click="clearConfigMenu">{{ $t('protocol.clear_menu') }}</el-button>
							</div>
							<el-checkbox-group v-model="editForm.configMenu">
								<el-checkbox v-for="item in configOptions" :key="item.value" :label="item.value">{{ item.label }}-{{ item.value }}</el-checkbox>
							</el-checkbox-group>
					</el-form-item>
				</el-form>
				<template #footer>
					<el-button @click="dialogVisible = false">{{ $t('device.cancel') }}</el-button>
					<el-button type="primary" @click="submitForm">{{ $t('device.confirm') }}</el-button>
				</template>
			</el-dialog>

			<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="[10, 20, 50, 100]" :page-size="searchForm.size" layout="total, sizes, prev, pager, next"
				:total="total"></el-pagination>
		</el-card>
	</div>
</template>

<script>
	import deviceProtocol from '@/model/deviceProtocol'

	export default {
		data() {
			return {
				searchForm: {
					name: '',
					page: 1,
					size: 20
				},
				tableData: [],
				total: 0,
				dialogVisible: false,
					editForm: {
						id: '',
						name: '',
						type: 1,
						description: '',
						configMenu: []
					},
					configOptions: [],
					protocolTypeOptions: [
						{ value: 1, label: 'HTTP-AEP' },
						{ value: 2, label: 'MQTT' },
						{ value: 3, label: '其它' }
					]
				}
			},
		computed: {
			editTitle() {
				return this.editForm.id ? this.$t('device.edit') : this.$t('goods.add')
			}
		},
		mounted() {
			this.getConfigOptions()
			this.search()
		},
		methods: {
				async getConfigOptions() {
					const res = await deviceProtocol.batchMenuOptions({ type: 27 })
					if (res.code === 200) {
						this.configOptions = Object.entries(res.data.options).map(([key, item]) => ({
							value: Number(key),
							label: item.title
						}))
					}
				},
			async search() {
				const res = await deviceProtocol.lists(this.searchForm)
				if (res.code === 200) {
					this.tableData = res.data.list
					this.total = res.data.total
				}
			},
			reset() {
				this.searchForm.name = ''
				this.searchForm.page = 1
				this.search()
			},
				handleEdit(row) {
					const config = this.parseConfig(row.config)
					this.editForm = row.id ? {
						...row,
						configMenu: (config.menu || []).map(item => Number(item))
					} : {
						id: '',
						name: '',
						type: 1,
						description: '',
						configMenu: []
					}
					this.dialogVisible = true
				},
				parseConfig(config) {
					if (!config) {
						return {}
					}
					if (typeof config === 'string') {
						try {
							return JSON.parse(config) || {}
						} catch (e) {
							return {}
						}
					}
					return config
				},
				applyDefaultMenu() {
					this.editForm.configMenu = this.configOptions.map(item => item.value)
				},
				clearConfigMenu() {
					this.editForm.configMenu = []
				},
			handleDelete(row) {
				this.$confirm(this.$t('goods.confirm_delete'), this.$t('goods.tip'), {
					type: 'warning'
				}).then(async () => {
					const res = await deviceProtocol.delete({ id: row.id })
					if (res.code === 200) {
						this.search()
					} else {
						this.$message.error(res.message)
					}
				})
			},
				async submitForm() {
					const params = {
						...this.editForm,
						config: { menu: this.editForm.configMenu.map(item => Number(item)) }
					}
				delete params.configMenu
				const res = await deviceProtocol.operate(params)
				if (res.code === 200) {
					this.dialogVisible = false
					this.search()
				} else {
					this.$message.error(res.message)
				}
			},
			handleCurrentChange(page) {
				this.searchForm.page = page
				this.search()
			},
			handleSizeChange(size) {
				this.searchForm.size = size
				this.searchForm.page = 1
				this.search()
			}
		}
	}
</script>
